// Asks node for the browser's feature flags before the first render (docs/specs/runtime-flags.md).
// Resolves to node's JSON object, or null on any failure (404 on a node without the route, network error, timeout,
// bad JSON, not an object). Never rejects: a null leaves every runtime flag off, which is today's login.
import urls from "../Utils/urls";

const DEFAULT_TIMEOUT_MS = 3000;

// Same base the MFA services use (src/services/mfa/mfaApi.js): .../api/v1
export const clientFlagsUrl = () =>
  urls.admin.getAuthToken.replace(/\/auth\/get_auth_token$/, "") + "/config/client-flags";

export const loadClientFlags = async ({
  url = clientFlagsUrl(),
  fetchImpl = typeof fetch === "function" ? fetch : null,
  timeoutMs = DEFAULT_TIMEOUT_MS,
} = {}) => {
  if (!fetchImpl) return null;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetchImpl(url, { method: "GET", cache: "no-store", signal: controller.signal });
    if (!res.ok) {
      console.warn(`[client-flags] ${url} answered ${res.status}; flags stay off`);
      return null;
    }
    const body = await res.json();
    return body !== null && typeof body === "object" && !Array.isArray(body) ? body : null;
  } catch (err) {
    console.warn(`[client-flags] ${url} failed (${err?.message ?? err}); flags stay off`);
    return null;
  } finally {
    clearTimeout(timer);
  }
};
